import React, { FC } from 'react';
import { CardBody, CardHeader, FormGroup } from 'reactstrap';
import { RoleSelection } from '../../../../components/RoleSelection';
import { useTranslation } from '../../../../translations';

interface RoleSelectorProps {
  readonly selectedIds: number[];
  readonly setSelectedIds: (vals: number[]) => void;
}

export const RoleSelector: FC<RoleSelectorProps> = ({ selectedIds, setSelectedIds }) => {
  const { ts } = useTranslation();
  return (
    <>
      <CardHeader>{ts('raffles.editor.roleOverride')}</CardHeader>
      <CardBody>
        <FormGroup>
          <p>{ts('raffles.editor.roleOverride.help')}</p>
          <RoleSelection
            permissionError={ts('raffles.editor.roleOverride.permissionError')}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
        </FormGroup>
      </CardBody>
    </>
  );
};
